import styled from 'styled-components';

export const InputContainer = styled.div`
  position: relative;
`;

export const EndContent = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
